module.exports = __webpack_public_path__ + "media/images/rotated_landing_page-d7169c5d99b3ee21cdbee6dc9e28d6b0.png";